<template>
  <div class="mobile-audit-container">
    <div class="table-title">
      <div class="title-left">
        <i class="el-icon-s-management" />审批信息
      </div>
    </div>

    <div class="form-content">
      <template v-for="item in formConifg">
        <div class="form-one" :key="item.prop">
          <div class="form-title">
            <div class="title-circle"></div>{{item.label}}
          </div>
          <template v-if="item.component == 'wf-users-opinion'">
            <div class="input-one" :key="index" v-for="(i, index) in item.variables">
              <el-input
                class="form-content"
                :disabled="i.disabled"
                type="textarea"
                placeholder="请输入审批意见"
                v-model="i.opinionContent"
                maxlength="100"
                rows="4"
                @blur="changeText"
              >
              </el-input>
              <div class="sign-content-copy" v-if="i.opinionSign != ''">{{i.opinionSign}}</div>
            </div>
          </template>
          <template v-else>
            <el-input
              class="form-content"
              :disabled="item.disabled"
              type="textarea"
              placeholder="请输入审批意见"
              v-model="item.variables"
              maxlength="100"
              rows="4"
              @blur="changeText"
            >
            </el-input>
            <div class="sign-content" v-if="item.sign != ''">{{item.sign}}</div>
          </template>

        </div>
      </template>
    </div>
  </div>
</template>
<script>
import workFlow from '@/mixins/workFlow'
export default {
  name: "MobileAuditInfo",
  mixins: [workFlow],
  data() {
    return {
      formData: {},
      formConifg: [],
      usersOpinions: []
    }
  },
  props: {
    /**
     * @param {String} processId 流程ID
     */
    processId: {
      type: String,
      default: ''
    },

    formDetailData: {
      type: Object,
      default: () => {
        return {}
      }
    },

    /**
     * @param {String} status 流程状态todo/done
     */
    status: {
      type: String,
      default: 'done'
    },
    /**
     * @param {Boolean} isEditable 是否可编辑
     */
    isEditable: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    formDetailData: {
      handler(val) {
        if(val.allAppForm) this.dealForm(val)
      },
      immediate: true,
      deep: true
    }
  },
  computed: {
    commentDetail() {
      return this.$refs.basicInfo?this.$refs.basicInfo.propOption:{}
    }
  },  
  mounted() {

  },
  methods: {
    changeText() {
      this.$emit('changeFormData', this.formConifg)
    },
    dealForm(val) {
      let self = this
      let config = JSON.parse(val.allAppForm)
      if(this.status == 'done') {
        config.column.forEach(item => {
          item.disabled = true
        })
      }
      
      if(val.taskForm){
        // 处理绑定数据 提取val中的数据
        config.column.map(item => {
          let filterObj = val.taskForm.filter(obj => {
            return obj.id === item.prop
          })
          if(filterObj&& filterObj.length> 0){
            item.display = filterObj[0].readable?true: false
            item.disabled = filterObj[0].writable?false: true
            item.required = filterObj[0].required?true: false
            // self.formData[item.prop] = filterObj[0].value
            self.$set(self.formData, item.prop, filterObj[0].value)
            if(item.component == 'wf-users-opinion'){
              item.variables = filterObj[0].value != ''?JSON.parse(filterObj[0].value):''
            }else {
              item.variables = filterObj[0].value != ''?JSON.parse(filterObj[0].value).opinionContent:''
              item.sign = filterObj[0].value != ''?JSON.parse(filterObj[0].value).opinionDate:''
            }
            item.value = filterObj[0].value
          }else{
            item.display = false,
            item.disabled = true,
            item.required = false
          }
        })
        // 从val.taskForm中以id为key提取value数据，重组成formData
        val.taskForm.map(item => {
          self.$set(self.formData, item.id, item.value)
        })
      } else {
        // 无taskForm数据，直接提取process中variables数据，并设置表单为只读
        config.column.map(item => {
          self.$set(self.formData, item.prop, val.variables[item.prop])
          if(item.component == 'wf-users-opinion'){
            item.variables = val.variables[item.prop] && val.variables[item.prop] !='' ?JSON.parse(val.variables[item.prop]):''
          } else {
            item.variables = val.variables[item.prop] && val.variables[item.prop] !='' ?JSON.parse(val.variables[item.prop]).opinionContent:''
            item.sign = val.variables[item.prop] && val.variables[item.prop] !='' ?JSON.parse(val.variables[item.prop]).opinionDate: ''
          }
          item.disabled = !self.isEditable
        })
      }
      this.formConifg = config.column
      this.$forceUpdate()
    },

    validData() {
      let finish = true
      let submitData = this.dealAuditForm(this.formData, this.commentDetail)
      this.mobileFormConifg.map(item => {
        if(!item.disabled && item.required && submitData[item.prop] == '') {
          this.$message.error('请补全' + item.label +'审批意见')
          this.$el.querySelector('#infoHead').scrollIntoView()
          finish = false
        }
      })
      return finish
    }
  }
}
</script>
<style lang="scss" scoped>
.mobile-audit-container{
  padding-left: .3rem;
  padding-right: .3rem;
  margin-bottom: .2rem;
  /deep/ .el-textarea__inner {
    font-size: 0.38rem;
    color: #333;
    padding: 10px 15px;
  }
  .table-title{
    width: 100%;
    height: 1rem;
    line-height: 1rem;
    margin-top: .2rem;
    .title-left{
      font-size: 0.38rem;
      color: #666;
      font-weight: 600;
    }
  }

  .form-content{
    .form-one{
      margin-bottom: 0.25rem;
      position: relative;
      .form-title{
        font-size: 0.36rem;
        font-weight: 600;
        color: #999;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        line-height: .7rem;
        .title-circle{
          width: .25rem;
          height: .25rem;
          border-radius: .125rem;
          border: 2px solid #409eff;
          background-color: #fff;
          margin-right: .3rem;
          margin-left: .2rem;
        }
      }
      .sign-content{
        position: absolute;
        right: .25rem;
        bottom: .1rem;
        font-size: 0.38rem;
        color: #666;
      }
    }
    .input-one{
      position: relative;
      margin-bottom: 0.2rem;
      .sign-content-copy{
        position: absolute;
        right: .25rem;
        bottom: .1rem;
        font-size: 0.38rem;
        color: #666;
      }
    }
  }
}
</style>